import React, { useContext } from 'react';

import * as S from './styles';

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

import { currencyFormater } from '@/utils/formatCurrency';

const CardInfo: React.FC = () => {
  const { paymentLinkData, userData, getSimulationData } =
    useContext(PaymentLinkContext);

  const totalValue = getSimulationData?.installments.find(
    i => i.number === Number(userData?.installments || 0),
  )?.total_amount;

  return (
    <S.Container>
      {paymentLinkData?.amount && (
        <S.CustomRow>
          <S.Value>{currencyFormater(Number(paymentLinkData?.amount))}</S.Value>
          <S.Description>
            Pagando {paymentLinkData?.business_name}
          </S.Description>
        </S.CustomRow>
      )}

      {paymentLinkData?.description && (
        <S.CustomRow>
          <S.Description>Descrição</S.Description>
          <S.Info>{paymentLinkData.description}</S.Info>
        </S.CustomRow>
      )}

      {totalValue && totalValue > 0 && (
        <S.CustomRow>
          <S.Description>Valor a pagar</S.Description>
          <S.Info>{currencyFormater(totalValue)}</S.Info>
        </S.CustomRow>
      )}
    </S.Container>
  );
};

export default CardInfo;
